export default __webpack_public_path__ + "static/media/alerta.980deef1.png";